var MOBILE_PORTRAIT   = 1;
var MOBILE_LANDSCAPE  = 2;
var TABLET_PORTRAIT   = 3;
var TABLET_LANDSCAPE  = 4;
var DESKTOP           = 4;

var Courses = {
  DEBUG : false,
  currentCourse : {
    folder : null,
    unitJSON : null,
    JSONTrainingData : null,
    permanentData : null,// - THIS IS LIKE JSON TRAINING DATA BUT WILL REMAIN
    companyLogo : null,
    currentSectionIdx : 0,
    currentSlideIdx : 0,
    timelines : [],
    progress : [],// - THIS IS THE 2D ARRAY OF SECTIONS AND SLIDES, 0 - NS, 1 - I, 2 - C
    progressPerc : 0,
    mode : 'linear',
  },

  init : function () {
    // - REFRESH BUTTON CLICK EVENTS
    Courses.refreshEvents();
    // - SET ONFULLSCREENCHANGE
    Courses.accessibility.fullScreen.init();
    // - GET SIZE AND ORIENTATION
    Courses.deviceProfile = Courses.getDeviceProfileAndOrientation();
    // - DETECT SIZE AND ORIENTATION ON RESIZE AND ON ORIENTATION CHANGE EVENTS
    Courses.initDetectDeviceOrientationChange();
    // - SETTINGS BASED ON DEVICE PROFILE
    switch ( Courses.deviceProfile.mode ) {
      case MOBILE_PORTRAIT:
        Courses.content.slidePosition.left = '5%';
        break;
      default:
        Courses.content.slidePosition.left = '0';
    }

    if ( Courses.DEBUG ) {
      $('.apollo').append (
        $('<div></div>')
          .addClass ( 'debug' )
      );
    }
  },

  initCourse : function ( courseObj ) {
    Courses.currentCourse.folder           = courseObj.folder;
    Courses.currentCourse.unitJSON         = courseObj.unitJSON;
    Courses.currentCourse.companyLogo      = courseObj.companyLogo;
    Courses.currentCourse.uciID            = courseObj.uciID;
    Courses.currentCourse.JSONTrainingData = courseObj.JSONTrainingData;
    Courses.currentCourse.permanentData    = courseObj.permanentData;

    CourseLog.addEntry ( 1, '' );

    Courses.content.loadSlide (
      Courses.currentCourse.JSONTrainingData.curr_section, Courses.currentCourse.JSONTrainingData.curr_slide, '#next-slide', Courses.content.slideNextIn
    );

    // - THE FOLLOWING WAS ORIGINALLY SET IN INIT BUT WE NEED THE UCIID TO LOG THIS PROPERLY
    // - SET HOT KEYS ON
    Courses.accessibility.setHotKeysOn();
  },

  getSlideInfo : function ( sectionIdx, slideIdx ) {
    if ( sectionIdx === undefined && slideIdx === undefined ) {
      sectionIdx = Courses.currentCourse.currentSectionIdx;
      slideIdx = Courses.currentCourse.currentSlideIdx;
    }

    var slidePathArr = Courses.currentCourse.unitJSON.menuItems[sectionIdx].slides[slideIdx].path.split('/');
    var slidePath = slidePathArr[slidePathArr.length-2] + '/' + slidePathArr[slidePathArr.length-1];

    var obj = {
      courseTitle: Courses.currentCourse.unitJSON.title,
      section: sectionIdx,
      slide: slideIdx,
      slideTitle: Courses.currentCourse.unitJSON.menuItems[sectionIdx].slides[slideIdx].title,
      fullSlidePath: Courses.currentCourse.unitJSON.menuItems[sectionIdx].slides[slideIdx].path,
      slidePath: slidePath,
      slideFile: Courses.currentCourse.unitJSON.menuItems[sectionIdx].slides[slideIdx].file,
      slideLayout: Courses.currentCourse.unitJSON.menuItems[sectionIdx].slides[slideIdx].layout,
      thisSlide: JSON.stringify ( Courses.currentCourse.currentSlide ),
      thisMenuItem: JSON.stringify ( Courses.currentCourse.currentMenuItem ),
    };

    if ( window.location.href.indexOf ( 'local' ) !== -1 ) {
      console.table(obj);
    }

    return obj;
  },

  addSlideToNextPositionJSON : function ( custom, assessment, _dataObj ) {
    // - TO USE GO TO THE SLIDE BEFORE WHERE YOU WANT THE NEW SLIDE TO APPEAR
    // - IN CONSOLE USE: Courses.addSlideToNextPositionJSON ( [args] );
    var dataObj = _dataObj === undefined ? {} : _dataObj;

    var slideObj = {
      s: 0,
      c: custom ? 1 : 0,
      a: assessment ? 1 : 0,
      d: dataObj,
    };

    console.log(JSON.stringify(Courses.currentCourse.JSONTrainingData));
    // - FIRST MOVE OTHER SLIDES BACK ONE
    var slidesLength = Object.size (
      Courses.currentCourse.JSONTrainingData.sections[Courses.currentCourse.currentSectionIdx].slides
    );

    for ( var i = slidesLength - 1; i > Courses.currentCourse.currentSlideIdx; i-- ) {
      console.log(i, '=>', i+1);
      console.log(Courses.currentCourse.JSONTrainingData.sections[Courses.currentCourse.currentSectionIdx].slides[i]);
      Courses.currentCourse.JSONTrainingData.sections[Courses.currentCourse.currentSectionIdx].slides[i+1] = Courses.currentCourse.JSONTrainingData.sections[Courses.currentCourse.currentSectionIdx].slides[i];
    }

    // - NOW INSERT THE NEW ONE
    Courses.currentCourse.JSONTrainingData.sections[Courses.currentCourse.currentSectionIdx].slides[i+1] = slideObj;

    console.log(JSON.stringify(Courses.currentCourse.JSONTrainingData));

    Courses.content.saveJSONTrainingData();
  },

  allCoursesInit : function() {
    Courses.activateEnrolBtns();
    Courses.activateResetBtns();
  },

  activateEnrolBtns : function() {
    $('.course-enrol-btn')
      .off ( 'click' )
      .on  ( 'click', function ( evt ) {
        Courses.showEnrolPopup ( $(this).attr('data-course-id') );
      });
  },

  activateResetBtns : function() {
    $('.course-reset-btn')
      .off ( 'click' )
      .on  ( 'click', function ( evt ) {
        Courses.showResetCoursePopup ( $(this).attr('data-course-id'), $(this).attr('data-uci-id') );
      });
  },

  showEnrolPopup : function ( courseID ) {
    popup.generatePopup({
      title: 'Enrol on a Course',
      method: 'ajax',
      ajaxUrl: '/ajax/AJAX-courses/show-enrol-popup',
      width: 700,
      height: 600,
      success: function() {
      },
    });
  },

  enrolAndLaunch : function ( courseCode, studentID, department, tutor ) {
    var sendData = {
      courseCode : courseCode,
      studentID : studentID === '' ? 'nil' : studentID,
      department : department === '' ? 'nil' : department,
      tutor : tutor === '' ? 'nil' : tutor,
    };

    $.ajax({
      url: '/ajax/AJAX-courses/enrol-and-send-launch',
      data: sendData,
      type: 'post',
      dataType: 'json',
      success: function ( returnedData ) {
        // console.log(returnedData);
        if ( returnedData.success ) {
          window.location.href = '/course/' + returnedData.attemptID;
        }
      },
    });
  },

  showResetCoursePopup : function ( courseID, uciID ) {
    popup.generatePopup({
      title: 'Reset Course?',
      method: 'ajax',
      ajaxUrl: '/ajax/AJAX-courses/show-reset-popup',
      data: {
        courseID : courseID,
        uciID : uciID,
      },
      width: 700,
      height: 600,
      success: function() {
      },
    });
  },

  softReset : function() {
    // - RESETS THE CURRENT COURSE PROGRESS
    for ( var i in Courses.currentCourse.JSONTrainingData.sections ) {
      for ( var j in Courses.currentCourse.JSONTrainingData.sections[i].slides ) {
        console.log(Courses.currentCourse.JSONTrainingData.sections[i].slides[j]);
        Courses.currentCourse.JSONTrainingData.sections[i].slides[j].s = 0;
        Courses.currentCourse.JSONTrainingData.sections[i].slides[j].d = {};
      } 
    }

    Courses.currentCourse.JSONTrainingData.curr_section = 0;
    Courses.currentCourse.JSONTrainingData.curr_slide = 0;

    console.log(Courses.currentCourse.JSONTrainingData);

    Courses.content.saveJSONTrainingData();
  },

  deviceProfile : null,

  getDeviceProfileAndOrientation : function() {
    var mode;

    // - DESKTOPS & TABLET L - W > H && W > 960 - SHOW IT IN NORMAL MODE
    if ( $(window).width() > $(window).height() && $(window).width() > 960 ) {
      mode = 4;
    }
    // - TABLET P W < H && W > 700 - SHOW IN TABLET MODE
    if ( $(window).width() < $(window).height() && $(window).width() > 700 ) {
      mode = 3;
    }
    // - PHONE L W > H & W <= 768 - SHOW IN MOBILE MODE
    if ( $(window).width() > $(window).height() && $(window).width() <= 768 ) {
      mode = 2;
    }
    // - PHONE P W < H & W <= 640 - FORCE TO LANDSCAPE
    if ( $(window).width() < $(window).height() && $(window).width() <= 640 ) {
      mode = 1;
    }

    return {
      mode : mode,
      w : $(window).width(),
      h : $(window).height(),
    };
  },

  initDetectDeviceOrientationChange : function() {
    window.addEventListener ( 'resize', Courses.getDeviceProfileAndOrientation, false );
    window.addEventListener ( 'orientationchange', Courses.getDeviceProfileAndOrientation, false );
  },

  setPassed : function() {
    var sendData = {
      uciID : Courses.currentCourse.uciID,
    };

    $.ajax({
      url: '/ajax/AJAX-courses/set-passed',
      type: 'post',
      data: sendData,
      dataType: 'json',
      success: function ( returnedData ) {
        // console.log(returnedData);
      },
    });
  },

  refreshEvents : function() {
    Courses.menu.refreshMenuEvents();
    Courses.footerNav.refreshEvents();
  },

  fullScreen : false,
  toggleFullScreen : function() {
    if ( Courses.fullScreen ) {
      CourseLog.addEntry ( 17, '' );

      Misc.exitFullScreen();
    }
    else {
      Courses.fullScreen = true;

      var matchRectObj = Misc.fillInnerRectToMatchOuterRect (
        {
          width:900,
          height:500,
        },
        {
          width:$(window).innerWidth(),
          height:$(window).innerHeight(),
        }
      );

      TweenMax.set ( '.apollo', {
        position: 'absolute',
      });

      // - MAKE FULL SCREEN
      TweenMax.to ( '.apollo', 0.5, {
        width  : '100%',
        height : '100%',
        top    : 0,
      });

      TweenMax.to ( '.apollo-content', 0.5, {
        top: '50%',
        left: '50%',
        width: '900px',
        height: '438px',
        transform: 'matrix(' + matchRectObj.incFactor + ',0,0,' + matchRectObj.incFactor + ',-450,-250)',
      });

      $('#full-screen-btn i, #full-screen-btn svg')
        .addClass ( 'fa-compress' )
        .removeClass ( 'fa-expand' );

      var elem = document.body; // Make the body go full screen.
      Misc.requestFullScreen(elem);

      CourseLog.addEntry ( 16, '' );

      // - SPECIAL ACTION FOR MOBILE
      if ( Courses.deviceProfile.mode === MOBILE_LANDSCAPE ) {
        TweenMax.set ( 'body', {
          position: 'absolute',
          width: '100%',
        });
      }
    }
  },

  apolloExitFullScreen : function() {
    // - REVERT TO NORMAL
    Courses.fullScreen = false;

    TweenMax.set ( '.apollo', {
      position: 'relative',
    });

    TweenMax.to ( '.apollo', 0.5, {
      width  : '900px',
      height : '500px',
    });

    TweenMax.to ( '.apollo-content', 0.5, {
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      transform: 'matrix(1,0,0,1,0,0)',
    });

    $('#full-screen-btn i, #full-screen-btn svg')
      .addClass ( 'fa-expand' )
      .removeClass ( 'fa-compress' );
  },

  utils : {
    getTotalSlides : function() {
      var total = 0;

      for ( var section in Courses.currentCourse.JSONTrainingData.sections ) {
        total += Object.size ( Courses.currentCourse.JSONTrainingData.sections[section].slides );
      }

      return total;
    },

    getCurrentSlideOverallIndex : function() {
      var total = 0;
      
      for ( var i = 0; i < Object.size ( Courses.currentCourse.JSONTrainingData.sections ); i++ ) {
        if ( i < Courses.currentCourse.currentSectionIdx ) {
          total += Object.size ( Courses.currentCourse.JSONTrainingData.sections[i].slides );
        }
        else if ( i == Courses.currentCourse.currentSectionIdx ) {
          total += Courses.currentCourse.currentSlideIdx + 1;
        }
        else {
          break;
        }
      }

      return total;
    },

    getProgress : function() {
      // - SLIDE STATUS
      var currentSlideStatus = Courses.currentCourse.JSONTrainingData.sections[Courses.currentCourse.currentSectionIdx].slides[Courses.currentCourse.currentSlideIdx].s;
      var overallSlideIdx = Courses.utils.getCurrentSlideOverallIndex();
      var totalSlides = Courses.utils.getTotalSlides();

      if ( currentSlideStatus == 2 ) {
        return overallSlideIdx / totalSlides;
      }
      else {
        if ( overallSlideIdx === 0 ) {
          return 0;
        }
        else {
          return (overallSlideIdx - 1) / totalSlides;
        }
      }
    },

    notes : {
      mode : 'slide',// - slide|all
      showing : false,
      keyTimer_TO : null,

      show : function() {
        CourseLog.addEntry ( 12, '' );

        Courses.utils.notes.showing = true;

        $('#toggle-all-or-slide-btn')
          .off ( 'click' )
          .on  ( 'click', function ( evt ) {
            if ( $(this).find('svg').hasClass ( 'fa-toggle-on' ) ) {
              $(this).find('svg')
                .switchClass ( 'fa-toggle-on', 'fa-toggle-off' );
              $(this).find('span')
                .text ( 'Slide Notes' );

              Courses.utils.notes.showSlideNotes();
            }
            else {
              $(this).find('svg')
                .switchClass ( 'fa-toggle-off', 'fa-toggle-on' );
              $(this).find('span')
                .text ( 'All Notes' );

              Courses.utils.notes.showAllNotes();
            }
          });

        $('#close-notes-popout-btn')
          .off ( 'click' )
          .on  ( 'click', function ( evt ) {
            Courses.utils.notes.hide();
          });

        if ( Courses.utils.notes.mode === 'slide' ) {
          $('#slide-notes')
            .off ( 'focus' )
            .on  ( 'focus', function ( evt ) {
              // - SET THE HOT KEYS OFF
              Courses.accessibility.setHotKeysOff();

              // - IF MOBILE AND LANDSCAPE, THE KEYBOARD WILL COVER THE NOTES SO WE'LL MOVE IT TO TOP:0
              if ( Courses.deviceProfile.mode === MOBILE_LANDSCAPE ) {
                $('#notes-popout')
                  .removeClass ( 'opened' )
                  .addClass ( 'opened-mobile-ls' );
              }
              else if ( Courses.deviceProfile.mode === TABLET_PORTRAIT ) {
                $('#notes-popout')
                  .removeClass ( 'opened' )
                  .addClass ( 'opened-tablet-pt' );
              }
            });

          $('#slide-notes')
            .off ( 'blur' )
            .on  ( 'blur', function ( evt ) {
              Courses.accessibility.setHotKeysOn();
            });

          $('#slide-notes')
            .off ( 'keyup' )
            .on  ( 'keyup', function ( evt ) {
              var sectionIdx = Courses.currentCourse.currentSectionIdx;
              var slideIdx   = Courses.currentCourse.currentSlideIdx;
              
              if ( Courses.currentCourse.permanentData.notes === undefined ) {
                Courses.currentCourse.permanentData.notes = {};
              }

              if ( Courses.currentCourse.permanentData.notes[sectionIdx] === undefined ) {
                Courses.currentCourse.permanentData.notes[sectionIdx] = {};
              }

              Courses.currentCourse.permanentData.notes[sectionIdx][slideIdx] = $(this).val();

              clearTimeout ( Courses.utils.notes.keyTimer_TO );
              Courses.utils.notes.keyTimer_TO = setTimeout ( function() {
                Courses.content.savePermanentData();
              }, 2500 );
            });

          $('#slide-notes').show();

          $('#slide-notes').val ( Courses.utils.notes.getSlideNotes() );

          // - TOGGLE THE OPENED AND CLOSED CLASSES
          $('#notes-popout').removeClass ( 'closed' );
          $('#notes-popout').addClass ( 'opened' );

          if ( Courses.deviceProfile.mode === MOBILE_LANDSCAPE ) {
            $('#notes-popout')
              .removeClass ( 'opened' )
              .addClass ( 'opened-mobile-ls' );
          }
          else if ( Courses.deviceProfile.mode === TABLET_PORTRAIT ) {
            $('#notes-popout')
              .removeClass ( 'opened' )
              .addClass ( 'opened-tablet-pt' );
          }
        }
        else {
          $('#slide-notes').hide();
        }

      },

      hide : function() {
        CourseLog.addEntry ( 13, '' );

        Courses.utils.notes.showing = false;

        $('#toggle-all-or-slide-btn')
          .off ( 'click' );

        $('#close-notes-popout-btn')
          .off ( 'click' );

        $('#slide-notes')
          .off ( 'focus' );

        $('#slide-notes')
          .off ( 'blur' );

        Courses.accessibility.setHotKeysOn();

        // - TOGGLE THE OPENED AND CLOSED CLASSES
        $('#notes-popout').removeClass ( 'opened' );
        $('#notes-popout').addClass ( 'closed' );
      },

      toggle : function() {
        if ( Courses.utils.notes.showing ) {
          Courses.utils.notes.hide();
        }
        else {
          Courses.utils.notes.show();
        }
      },

      getSlideNotes : function() {
        var sectionIdx = Courses.currentCourse.currentSectionIdx;
        var slideIdx   = Courses.currentCourse.currentSlideIdx;

        var noNotes = Courses.currentCourse.permanentData.notes === undefined ||
                      Courses.currentCourse.permanentData.notes[sectionIdx] === undefined ||
                      Courses.currentCourse.permanentData.notes[sectionIdx][slideIdx] === undefined;

        if ( noNotes ) {
          return '';
        }
        else {
          return Courses.currentCourse.permanentData.notes[sectionIdx][slideIdx];
        }
      },

      showSlideNotes : function() {
        CourseLog.addEntry ( 15, '' );

        $('#all-notes').hide();
        $('#slide-notes').show();
      },

      showAllNotes : function() {
        CourseLog.addEntry ( 14, '' );

        var allNotesText = '';
        if ( Courses.currentCourse.permanentData.notes !== undefined ) {
          for ( var i in Courses.currentCourse.permanentData.notes ) {
            for ( var j in Courses.currentCourse.permanentData.notes[i] ) {
              if ( Courses.currentCourse.permanentData.notes[i][j] !== undefined ) {
                // - GET THE TITLE
                allNotesText += '<strong>' + Courses.currentCourse.unitJSON.menuItems[i].title + ' &gt; ' + Courses.currentCourse.unitJSON.menuItems[i].slides[j].title + '</strong><br>';
                // - GET THE NOTES
                allNotesText += '<pre>' + Courses.currentCourse.permanentData.notes[i][j] + '</pre>-----------------------------------<br><br>';
              }
            }
          }
        }

        $('#all-notes').html(allNotesText);

        $('#all-notes').show();
        $('#slide-notes').hide();
      },

    },

    feedback : {
      send : function ( feedback, callback ) {
        var sendData = {
          uciID : Courses.currentCourse.uciID,
          feedback : 'juiceportal: ' + feedback,
        };

        $.ajax({
          url: '/ajax/AJAX-courses/send-feedback',
          data: sendData,
          type: 'post',
          dataType: 'json',
          success: function ( returnedData ) {
            // console.log(returnedData);
            if ( returnedData.success ) {
              callback();
            }
          }
        });
      },
    },

    help : {
      showing : false,

      show : function() {
        CourseLog.addEntry ( 20, '' );

        Courses.utils.help.showing = true;

        Courses.popup.showDynamicPopup (
          $('#help-guide-content').html(),
          {
            width  : '850px',
            height : '350px',
          }
        );
      },

      hide : function() {
        Courses.utils.help.showing = false;

        Courses.popup.closeDynamicPopup();
      },

      toggle : function() {
        if ( Courses.utils.help.showing ) {
          Courses.utils.help.hide();
        }
        else {
          Courses.utils.help.show();
        }
      },
    },
  },

  menu : {
    refreshMenuEvents : function() {
      $('.course-menu-item')
        .off ( 'click' )
        .on  ( 'click', function ( evt ) {
          var sectionIdx = $(this).data ( 'section-index' );
          var slideIdx = $(this).data ( 'slide-index' );
          var slideURL = $(this).data ( 'url' );

          CourseLog.addEntry ( 2, JSON.stringify({sectionIdx: sectionIdx, slideIdx: slideIdx, slideURL: slideURL}) );

          Courses.content.loadSlide (
            sectionIdx, slideIdx, '#next-slide', Courses.content.slideNextIn
          );

          Courses.menu.close();
        });

      $('#menu-open-close-btn')
        .off ( 'click' )
        .on  ( 'click', function ( evt ) {
          Courses.menu.toggle();
        });
    },

    open : function ( _duration ) {
      CourseLog.addEntry ( 5, '' );

      $('nav ul').scrollTop ( 0 );
      $('nav ul').scrollTop ( $("nav ul li.curr").offset().top - $("nav ul li.curr").parent().offset().top - 60 );

      // if ( _duration === undefined ) {
      //   _duration = 0.3;
      // }

      // $('.apollo nav.menu-nav').data ( 'state', 'open' );

      // $('#menu-open-close-btn').width(68);
      $('#menu-open-close-btn span')
        .text ( 'Close' );
      $('#menu-open-close-btn i, #menu-open-close-btn svg')
        .addClass ( 'fa-arrow-circle-left' )
        .removeClass ( 'fa-tasks' );

      // TweenMax.to ( '.apollo nav.menu-nav', _duration, {
      //   'left' : 0,
      //   'ease' : Cubic.easeOut,
      // });

      $('.apollo nav.menu-nav').addClass ( 'opened' );
      $('.apollo nav.menu-nav').removeClass ( 'closed' );
    },

    close : function ( _duration ) {
      // if ( _duration === undefined ) {
      //   _duration = 0.3;
      // }

      // $('.apollo nav.menu-nav').data ( 'state', 'closed' );

      // $('#menu-open-close-btn').width(65);
      $('#menu-open-close-btn span')
        .text ( 'Menu' );
      $('#menu-open-close-btn i, #menu-open-close-btn svg')
        .addClass ( 'fa-tasks' )
        .removeClass ( 'fa-arrow-circle-left' );

      // x = -$('.apollo nav.menu-nav').width();

      // TweenMax.to ( '.apollo nav.menu-nav', _duration, {
      //   'left' : x,
      //   'ease' : Cubic.easeOut,
      // });

      $('.apollo nav.menu-nav').addClass ( 'closed' );
      $('.apollo nav.menu-nav').removeClass ( 'opened' );
    },

    toggle : function() {
      if ( $('.apollo nav.menu-nav').hasClass ( 'opened' ) ) {
        Courses.menu.close();
      }
      else {
        Courses.menu.open();
      }
    },

    setSlideCompleteInMenu : function ( sectionIdx, slideIdx ) {
      var JSON = Courses.currentCourse.JSONTrainingData;
      if ( JSON.sections[sectionIdx].slides[slideIdx].s == 2 ) {
        $('.course-menu-item[data-section-index="' + sectionIdx + '"][data-slide-index="' + slideIdx + '"]').parent().addClass ( 'C' );
      }
    },

    markCurrMenuItem : function () {
      var sectionIdx = Courses.currentCourse.currentSectionIdx;
      var slideIdx = Courses.currentCourse.currentSlideIdx;

      $('.course-menu-item').parent().removeClass ( 'curr' );
      $('.course-menu-item[data-section-index="' + sectionIdx + '"][data-slide-index="' + slideIdx + '"]').parent().addClass ( 'curr' );
    },
  },

  popup : {
    currentPopupID : null,

    activatePopups : function() {
      $('#current-slide .dynamic-popup-btn')
        .off ( 'click.show-popup' )
        .on  ( 'click.show-popup', function ( evt ) {
          var popupID = $(this).data('popup-id');
          var popupContent = $('#current-slide .dynamic-popup-content[data-popup-id="' + popupID + '"]').html();

          Courses.popup.showDynamicPopup ( popupContent, Courses.popup.getOptions ( popupID ), popupID );
        });
    },

    getOptions : function ( popupID ) {
      var options = {};
      var popupSelectors = '#current-slide .dynamic-popup-content[data-popup-id="' + popupID + '"]';
      
      var attrs = $(popupSelectors)[0].attributes;

      for ( var i in attrs ) {
        if ( attrs[i].name === undefined || attrs[i].name.indexOf ( 'data-poption-' ) === -1 ) {
          continue;
        }

        var optionName = attrs[i].name.substr ( 'data-poption-'.length );

        options[optionName] = attrs[i].value;
      }
      
      return options;
    },

    close : function() {
      TweenMax.to ( '.dynamic-popup', 0.7, {
        top: '150%',
        boxShadow: '0 0 0 1000px rgba(0,0,0,0)',
      });
    },

    showKeyPopup : function() {
      // - IF THE SLIDE HAS A POPUP BUTTON, SHOW THIS POPUP
      if ( $('#current-slide .dynamic-popup-btn').length > 0 ) {
        $('#current-slide .dynamic-popup-btn:eq(0)').click();
      }
    },

    showDynamicPopup : function ( content, _options, _popupID ) {
      Courses.popup.currentPopupID = _popupID;

      $('#dynamic-popup-content-holder').html ( content );

      var options = {
        width: '500px',
        height: '300px',
        onClose: null,
      };
      if ( _options !== undefined ) {
        if ( _options.width !== undefined ) {
          options.width  = _options.width;
        }
        if ( _options.height !== undefined ) {
          options.height = _options.height;
        }
        if ( _options.onClose !== undefined ) {
          options.onClose = _options.onClose;
        }
      }

      var topPos;

      if ( Courses.deviceProfile.mode != 4 ) {
        $('#dynamic-popup')
          .css ( 'width', '100%' );

        $('#dynamic-popup-content-holder')
          .css ( 'width', '100%' )
          .css ( 'height', '100%' );
        
        topPos = 0;
      }
      else {
        $('#dynamic-popup')
          .css ( 'width', 'auto' );

        $('#dynamic-popup-content-holder')
          .css ( 'width', options.width )
          .css ( 'height', options.height );
        
        topPos = '50%';
      }

      TweenMax.to ( '#dynamic-popup', 0.6, {
        top: topPos,
        boxShadow: '0 0 0 1000px rgba(0,0,0,0.5)',
      });

      $('body')
        .off ( 'keydown.hotKeysEsc' )
        .on  ( 'keydown.hotKeysEsc', function ( evt ) {
          if ( evt.keyCode == 27 ) {
            Courses.popup.closeDynamicPopup ( options.onClose );
          }
        });

      $('#dynamic-popup-close-btn')
        .off ( 'click' )
        .on  ( 'click', function ( evt ) {
          Courses.popup.closeDynamicPopup ( options.onClose );

          $('body')
            .off ( 'keydown.hotKeysEsc' );
          
          $('#dynamic-popup-close-btn')
            .off ( 'click' );
        });

      if ( _popupID !== undefined ) {
        $('.dynamic-popup-content').attr('data-viewed',1);
        // - CHECK IF ALL POPUPS HAVE BEEN VIEWED FOR SIMPLE LAYOUTS AND SET STATUS TO 2
        if ( Courses.popup.allPopupsViewed() ) {
          Courses.content.setSlideStatus ( Courses.currentCourse.currentSectionIdx, Courses.currentCourse.currentSlideIdx, 2 );
          Courses.content.saveJSONTrainingData();
        }
      }
    },

    closeDynamicPopup : function ( onCloseCallback ) {
      Courses.popup.currentPopupID = null;

      CourseLog.addEntry ( 21, '' );
      
      TweenMax.to ( '#dynamic-popup', 0.6, {
        top: '200%',
        boxShadow: '0 0 0 1000px rgba(0,0,0,0)',
        onComplete : onCloseCallback,
      });
    },

    allPopupsViewed : function() {
      return $('.dynamic-popup-content').length === $('.dynamic-popup-content[data-viewed=1]').length;
    },
  },

  footerNav : {
    refreshEvents : function() {
      Courses.footerNav.enableNavBtns();

      $('#zoom-in-btn')
        .off ( 'click' )
        .on  ( 'click', function ( evt ) {
          Courses.accessibility.zoomIn();
        });

      $('#zoom-out-btn')
        .off ( 'click' )
        .on  ( 'click', function ( evt ) {
          Courses.accessibility.zoomOut();
        });

      $('#full-screen-btn')
        .off ( 'click.main-fs' )
        .on  ( 'click.main-fs', function ( evt ) {
          Courses.toggleFullScreen();
        });

      $('#info-btn')
        .off ( 'click.main-info' )
        .on  ( 'click.main-info', function ( evt ) {
          Courses.showSlideInfo();
        });

      $('#notes-btn')
        .off ( 'click' )
        .on  ( 'click', function ( evt ) {
          Courses.utils.notes.show();
        });

      $('#help-btn')
        .off ( 'click' )
        .on  ( 'click', function ( evt ) {
          Courses.utils.help.show();
        });
    },

    btnsEnabled : true,

    enableNavBtns : function() {
      $('#next-btn')
        .removeClass ( 'nav-btn-disabled' )
        .off ( 'click.next-general' )
        .on  ( 'click.next-general', function ( evt ) {
          CourseLog.addEntry ( 3, '' );
          Courses.content.next();
        });

      $('#previous-btn')
        .removeClass ( 'nav-btn-disabled' )
        .off ( 'click' )
        .on  ( 'click', function ( evt ) {
          CourseLog.addEntry ( 4, '' );
          Courses.content.previous();
        });

      Courses.footerNav.btnsEnabled = true;
    },

    disableNavBtns : function() {
      $('#next-btn')
        .addClass ( 'nav-btn-disabled' );

      $('#refresh-btn')
        .addClass ( 'nav-btn-disabled' );

      $('#previous-btn')
        .addClass ( 'nav-btn-disabled' );

      Courses.footerNav.btnsEnabled = false;
    },

    enableNextBtn : function() {
      $('#next-btn')
        .removeClass ( 'nav-btn-disabled' )
        .off ( 'click' )
        .on  ( 'click', function ( evt ) {
          CourseLog.addEntry ( 3, '' );
          Courses.content.next();
        });
    },

    disableNextBtn : function() {
      $('#next-btn')
        .addClass ( 'nav-btn-disabled' );
    },

    removeNextClick : function() {
      console.log('click off');
      $('#next-btn').off ( 'click.next-general' );
    }
  },

  content : {
    slideInit : function ( sectionIdx, slideIdx ) {
      if ( Courses.currentCourse.timelines[sectionIdx] === undefined ) {
        Courses.currentCourse.timelines[sectionIdx] = [];
      }
    },

    loadSlide : function ( sectionIdx, slideIdx, hostSelector, action ) {
      // - IF NOT FIRST SLIDE, GET THE PREVIOUS SLIDE'S STATUS TO DETERMINE IF WE CAN LOAD IT
      var canLoadSlide = Courses.content.canLoadSlide ( sectionIdx, slideIdx );
      if ( canLoadSlide.allowed ) {
        // - REMOVE THE Courses.content.customReasonNotComplete()
        Courses.content.customReasonNotComplete = null;

        var slideURL;
        var menuItems = Courses.currentCourse.unitJSON.menuItems;

        Courses.currentCourse.JSONTrainingData.last_section = Courses.currentCourse.currentSectionIdx;
        Courses.currentCourse.JSONTrainingData.last_slide = Courses.currentCourse.currentSlideIdx;
        delete Courses.currentCourse.JSONTrainingData.sections[Courses.currentCourse.JSONTrainingData.last_section].slides[Courses.currentCourse.JSONTrainingData.last_slide].curr;

        Courses.currentCourse.currentSectionIdx = sectionIdx;
        Courses.currentCourse.currentSlideIdx = slideIdx;
        Courses.currentCourse.currentSlide = Courses.currentCourse.JSONTrainingData.sections[sectionIdx].slides[slideIdx];
        Courses.currentCourse.currentMenuItem = Courses.currentCourse.unitJSON.menuItems[sectionIdx].slides[slideIdx];
        Courses.currentCourse.JSONTrainingData.curr_section = sectionIdx;
        Courses.currentCourse.JSONTrainingData.curr_slide = slideIdx;
        // console.log('last', Courses.currentCourse.lastSlide_SectionIdx, Courses.currentCourse.lastSlide_SlideIdx);
        // console.log('curr', sectionIdx, slideIdx);
        Courses.currentCourse.JSONTrainingData.sections[sectionIdx].slides[slideIdx].curr = true;

        CourseLog.addEntry ( 6, JSON.stringify({sectionIdx: sectionIdx, slideIdx: slideIdx}) );

        var sendData = {
          courseFolder : Courses.currentCourse.folder,
          companyLogo  : Courses.currentCourse.companyLogo,
          title        : menuItems[sectionIdx].slides[slideIdx].title,
          slidePath    : menuItems[sectionIdx].slides[slideIdx].path,
          layout       : menuItems[sectionIdx].slides[slideIdx].layout,
        };

        switch ( menuItems[sectionIdx].slides[slideIdx].layout ) {
          case 'assessment':
            slideURL = '/ajax/AJAX-assessment/loadAssessmentPlayer';
            sendData.assessmentJSON_URL = menuItems[sectionIdx].slides[slideIdx].path + '/' + menuItems[sectionIdx].slides[slideIdx].file;
            sendData.saveAssessmentAttemptFuncName = 'Assessment.player.saveAssessmentAttempt';
            sendData.onPass = 'Courses.assessment.assessmentPassed';
            
            break;
          case 'section-complete':
            if ( menuItems[sectionIdx+1] !== undefined ) {
              sendData.nextText = menuItems[sectionIdx+1].title;
            }

            slideURL = menuItems[sectionIdx].slides[slideIdx].path + '/' +
                       menuItems[sectionIdx].slides[slideIdx].file;
            break;
          case 'text-left-image-right':
            slideURL = menuItems[sectionIdx].slides[slideIdx].path + '/' +
                       menuItems[sectionIdx].slides[slideIdx].file;

            sendData.imgClass = 'image-right';
            sendData.textClass = 'text-left';
            break;
          case 'image-left-text-right':
            slideURL = menuItems[sectionIdx].slides[slideIdx].path + '/' +
                       menuItems[sectionIdx].slides[slideIdx].file;

            sendData.imgClass = 'image-left';
            sendData.textClass = 'text-right';
            break;
          case 'text-top-image-bottom':
            slideURL = menuItems[sectionIdx].slides[slideIdx].path + '/' +
                       menuItems[sectionIdx].slides[slideIdx].file;

            sendData.imgClass = 'image-bottom';
            sendData.textClass = 'text-top';
            break;
          case 'image-top-text-bottom':
            slideURL = menuItems[sectionIdx].slides[slideIdx].path + '/' +
                       menuItems[sectionIdx].slides[slideIdx].file;

            sendData.imgClass = 'image-top';
            sendData.textClass = 'text-bottom';
            break;
          case 'whole-text':
            slideURL = menuItems[sectionIdx].slides[slideIdx].path + '/' +
                       menuItems[sectionIdx].slides[slideIdx].file;

            sendData.textClass = 'text-full-width';
            break;
          case 'custom-text-image':
            slideURL = menuItems[sectionIdx].slides[slideIdx].path + '/' +
                       menuItems[sectionIdx].slides[slideIdx].file;

            sendData.textClass = '';
            sendData.imgClass = '';
            break;
          default:
            slideURL = menuItems[sectionIdx].slides[slideIdx].path + '/' +
                       menuItems[sectionIdx].slides[slideIdx].file;
            
            if ( Courses.deviceProfile.mode != DESKTOP && menuItems[sectionIdx].slides[slideIdx].mobileFile !== undefined ) {
              slideURL = menuItems[sectionIdx].slides[slideIdx].path + '/' +
                         menuItems[sectionIdx].slides[slideIdx].mobileFile;
            }
        }

        $.ajax({
          url: slideURL,
          type: 'post',
          data: sendData,
          dataType: 'html',
          success: function ( returnedData ) {
            CourseLog.addEntry ( 7, JSON.stringify({sectionIdx: sectionIdx, slideIdx: slideIdx}) );

            if ( Courses.DEBUG ) {
              var slideInfo = Courses.getSlideInfo();
              $('.debug').text ( slideInfo.slidePath );
            }

            $('#apollo-content ' + hostSelector).html ( returnedData );

            switch ( menuItems[sectionIdx].slides[slideIdx].layout ) {
              case 'section-complete':
              case 'text-left-image-right':
              case 'image-left-text-right':
              case 'text-top-image-bottom':
              case 'image-top-text-bottom':
              case 'whole-text':
              case 'custom-text-image':
                var status;
                if ( $('#apollo-content ' + hostSelector + ' .dynamic-popup-content').length > 0 ) {
                  status = 1;
                }
                else {
                  status = 2;
                }
                // - SET SLIDE STATUS
                Courses.content.setSlideStatus ( sectionIdx, slideIdx, status );
                Courses.content.saveJSONTrainingData();
                break;
              default:
                // - SET SLIDE STATUS TO 1
                Courses.content.setSlideStatus ( sectionIdx, slideIdx, 1 );
                Courses.content.saveJSONTrainingData();
            }

            // - MARK THE CURRENT SLIDE
            Courses.menu.markCurrMenuItem();

            // - ADJUST APOLLO CONTENT SCALE FOR TABLETS AND MOBILES HERE
            Courses.content.scaleToDevice();

            action();
          },
        });
      }
      else {
        if ( canLoadSlide.reason === 'previous-slide-incomplete' ) {
          CourseLog.addEntry ( 8, JSON.stringify({sectionIdx: sectionIdx, slideIdx: slideIdx}) );

          Courses.popup.showDynamicPopup (
            'Please ensure you have completed all previous slides to the one you\'re trying to access',
            {
              width  : '350px',
              height : '50px',
            }
          );
        }
      }
    },

    scaleToDevice : function() {
      var contentW = 900, contentH = 500, contentRatio = contentW / contentH;
      if ( Courses.deviceProfile.mode === MOBILE_LANDSCAPE ) {
        var matchRectObj = Misc.fillInnerRectToMatchOuterRect (
          {
            width:contentW,
            height:contentH,
          },
          {
            width:Courses.deviceProfile.w,
            height:Courses.deviceProfile.h - ($('#menu-btn').height() - 10),
          }
        );

        // $('#apollo-content').css('transform', 'scale(' + matchRectObj.incFactor + ')');
      }
    },

    getReasonSlideNotComplete : function ( sectionIdx, slideIdx ) {
      // - IF CUSTOM REASON FUNCTION IS NOT NULL THEN USE THIS
      if ( Courses.content.customReasonNotComplete !== null ) {
        return Courses.content.customReasonNotComplete();
      }
      // - ELSE IT'S NULL SO LOOK AT THE STANDARD REASONS
      else {
        var menuItems = Courses.currentCourse.unitJSON.menuItems;

        switch ( menuItems[sectionIdx].slides[slideIdx].layout ) {
          case 'section-complete':
          case 'text-left-image-right':
          case 'image-left-text-right':
          case 'text-top-image-bottom':
          case 'image-top-text-bottom':
          case 'whole-text':
          case 'custom-text-image':
            if ( $('#current-slide').find('.dynamic-popup-btn').length > 0 ) {
              return {
                reason : 'Please view each popup to continue.',
                popupDimensions : {
                  width  : '350px',
                  height : '50px',
                },
              };
            }
            break;
          default:
            return {
              reason : 'Please view each part of the slide content to continue.',
              popupDimensions : {
                width  : '350px',
                height : '50px',
              },
            };
        }
      }
    },

    completeIfSimpleNoPopups : function ( htmlContent ) {
      var menuItems  = Courses.currentCourse.unitJSON.menuItems,
          sectionIdx = Courses.currentCourse.currentSectionIdx,
          slideIdx   = Courses.currentCourse.currentSlideIdx;

      switch ( menuItems[sectionIdx].slides[slideIdx].layout ) {
        case 'section-complete':
        case 'text-left-image-right':
        case 'image-left-text-right':
        case 'text-top-image-bottom':
        case 'image-top-text-bottom':
        case 'whole-text':
        case 'custom-text-image':
          if ( $(htmlContent).find('.dynamic-popup-btn').length === 0 ) {
            // - SET SLIDE STATUS TO 2
            Courses.content.setSlideStatus ( sectionIdx, slideIdx, 2 );
            Courses.content.saveJSONTrainingData();
          }
          break;
        default:
      }
    },

    slideExists : function ( sectionIdx, slideIdx ) {
      if ( Courses.currentCourse.unitJSON.menuItems[sectionIdx] === undefined )
        return false;

      if ( Courses.currentCourse.unitJSON.menuItems[sectionIdx].slides[slideIdx] === undefined )
        return false;

      return true;
    },

    canLoadSlide : function ( sectionIdx, slideIdx ) {
      var output = {
        allowed : false,
      };

      var reasonPopup;
      if ( Courses.content.slideExists ( sectionIdx, slideIdx ) ) {
        output.info = Courses.getSlideInfo ( sectionIdx, slideIdx );

        if ( Courses.currentCourse.mode === 'free' ) {
          // - FREE
          output.allowed = true;
          return output;
        }
        else {
          // - LINEAR
          if ( sectionIdx === 0 && slideIdx === 0 ) {
            // - IT'S THE FIRST SLIDE
            output.allowed = true;
            return output;
          }
          else {
            if ( slideIdx === 0 ) {
              // - GET LAST SLIDE OF PREVIOUS SECTION
              var prevLastSlideIdx = Courses.content.getLastSlideIdxOfSection ( sectionIdx-1 );
              if ( Courses.content.getSlideStatus ( sectionIdx-1, prevLastSlideIdx ) === 2 ) {
                output.allowed = true;
                return output;
              }
              else {
                output.allowed = false;
                output.reason = 'previous-slide-incomplete';
                return output;
              }
            }
            else {
              // - GET THE PREVIOUS SLIDE
              if ( Courses.content.getSlideStatus ( sectionIdx, slideIdx-1 ) === 2 ) {
                output.allowed = true;
                return output;
              }
              else {
                output.allowed = false;
                output.reason = 'previous-slide-incomplete';
                return output;
              }
            }
          }
        }
      }
      else {
        // SLIDE DOESN'T EXIST
        output.info = false;
        output.reason = 'last-slide';
      }
      
      return output;
    },

    getLastSlideIdxOfSection : function ( sectionIdx ) {
      return Object.size ( Courses.currentCourse.unitJSON.menuItems[sectionIdx].slides ) - 1;
    },

    getSlideStatus : function ( sectionIdx, slideIdx ) {
      console.log(sectionIdx, slideIdx, Courses.currentCourse.JSONTrainingData.sections[sectionIdx].slides[slideIdx]);
      return Courses.currentCourse.JSONTrainingData.sections[sectionIdx].slides[slideIdx].s;
    },

    setSlideStatus : function ( sectionIdx, slideIdx, status, _force ) {
      // - SOMETIMES WE MAY WANT TO FORCE THE STATUS TO GO BACKWARDS BUT SELDOM
      var force = false;
      if ( _force !== undefined ) {
        force = _force;
      }
      
      if ( force || status > Courses.currentCourse.JSONTrainingData.sections[sectionIdx].slides[slideIdx].s ) {
        // - SET THE SLIDE STATUS
        Courses.currentCourse.JSONTrainingData.sections[sectionIdx].slides[slideIdx].s = status;
      }

      // - SET THE PROGRESS
      Courses.currentCourse.progressPerc = Math.round ( Courses.utils.getProgress() * 100 );

      // - IF COMPLETE HIGHLIGHT IN MENU
      Courses.menu.setSlideCompleteInMenu ( sectionIdx, slideIdx );
    },

    saveJSONTrainingData : function() {
      var sendData = {
        uciID : Courses.currentCourse.uciID,
        JSONTrainingData : JSON.stringify ( Courses.currentCourse.JSONTrainingData ),
        progressPerc : Courses.currentCourse.progressPerc,
      };

      $.ajax({
        url: '/ajax/AJAX-courses/save-json-training-data',
        type: 'post',
        data: sendData,
        dataType: 'json',
        success: function ( returnedData ) {
          console.log(returnedData);
        },
        error: function(err) {
          console.log(err);
        },
      });
    },

    savePermanentData : function() {
      var sendData = {
        uciID : Courses.currentCourse.uciID,
        permanentData : JSON.stringify ( Courses.currentCourse.permanentData ),
      };

      $.ajax({
        url: '/ajax/AJAX-courses/save-permanent-data',
        type: 'post',
        data: sendData,
        dataType: 'json',
        success: function ( returnedData ) {
          // console.log(returnedData);
        },
      });
    },

    getReasonCannotLoad : function ( sectionIdx, slideIdx ) {
      var menuItems        = Courses.currentCourse.unitJSON.menuItems,
          JSONTrainingData = Courses.currentCourse.JSONTrainingData,
          output           = {};

      switch ( menuItems[sectionIdx].slides[slideIdx].layout ) {
        case 'section-complete':
        case 'text-left-image-right':
        case 'image-left-text-right':
        case 'text-top-image-bottom':
        case 'image-top-text-bottom':
        case 'whole-text':
        case 'custom-text-image':
          if ( JSONTrainingData.sections[sectionIdx].slides[slideIdx].s === 1 ) {
            if ( ! Courses.popup.allPopupsViewed() ) {
              output.reason = 'Please view all the popups for this slide before moving on.';
              output.popupDimensions = {
                width  : '380px',
                height : '50px',
              };
            }
          }

          break;
        default:
          slideURL = menuItems[sectionIdx].slides[slideIdx].path + '/' +
                     menuItems[sectionIdx].slides[slideIdx].file;
          output = Courses.content.customReasonNotComplete();
      }

      return output;
    },

    customReasonNotComplete : function() {},// - SET IN THE SLIDE

    next : function() {
      if ( Courses.footerNav.btnsEnabled ) {
        var slideIdx = Courses.currentCourse.currentSlideIdx,
            sectionIdx = Courses.currentCourse.currentSectionIdx,
            nextSlideIdxs = Courses.content.getNextSlideIdxs(),
            nextSlideAccess = Courses.content.canLoadSlide ( nextSlideIdxs.sectionIdx, nextSlideIdxs.slideIdx );

        if ( nextSlideIdxs !== false ) {
          if ( nextSlideAccess.allowed ) {

            Courses.content.loadSlide (
              nextSlideIdxs.sectionIdx, nextSlideIdxs.slideIdx, '#next-slide', Courses.content.slideNextIn
            );

            Courses.footerNav.disableNavBtns();
          }
          else {//console.log('not allowed to load next');
            // - NOT ALLOWED TO LOAD SLIDE, SO WHY?
            // - GET REASON CURRENT SLIDE IS INCOMPLETE
            var reasonSlideNotComplete = Courses.content.getReasonSlideNotComplete ( Courses.currentCourse.currentSectionIdx, Courses.currentCourse.currentSlideIdx );

            Courses.popup.showDynamicPopup (
              reasonSlideNotComplete.reason, reasonSlideNotComplete.popupDimensions
            );
          }
        }
      }
    },

    getNextSlideIdxs : function() {
      var JSONTrainingData = Courses.currentCourse.JSONTrainingData,
          sectionIdx       = Courses.currentCourse.currentSectionIdx,
          slideIdx         = Courses.currentCourse.currentSlideIdx,
          output           = {
            sectionIdx : sectionIdx,
            slideIdx   : slideIdx,
          };

      // - IF CURRENT SLIDE IS NOT LAST SLIDE IN THE SECTION, SIMPLY INCREMENT
      if ( slideIdx < Object.size ( JSONTrainingData.sections[sectionIdx].slides ) - 1 ) {
        output.slideIdx++;
      }
      else {
        // - WE'RE ON THE LAST SLIDE
        // - IF CURRENT SECTION IS NOT LAST SECTION IN THE COURSE, SIMPLY INCREMENT SECTION AND SET SLIDE TO 0
        if ( sectionIdx < Object.size ( JSONTrainingData.sections ) - 1 ) {
          output.sectionIdx++;
          output.slideIdx = 0;
        }
        else {
          return false;
        }
      }

      return output;
    },

    getPrevSlideIdxs : function ( sectionIdx, slideIdx ) {
      var JSONTrainingData = Courses.currentCourse.JSONTrainingData,
          output           = {
            sectionIdx : sectionIdx,
            slideIdx   : slideIdx,
          };

      // - IF CURRENT SLIDE IS NOT FIRST SLIDE IN THE SECTION, SIMPLY DECREMENT
      if ( slideIdx > 0 ) {
        output.slideIdx--;
      }
      else {
        // - WE'RE ON THE FIRST SLIDE
        // - IF CURRENT SECTION IS NOT FIRST SECTION IN THE COURSE, SIMPLY DECREMENT SECTION AND SET SLIDE TO LAST OF PREVIOUS SECTION
        if ( sectionIdx > 0 ) {
          output.sectionIdx--;
          output.slideIdx = Courses.content.getLastSlideIdxOfSection ( sectionIdx - 1 );
        }
        else {
          return false;
        }
      }

      return output;
    },

    slidePosition : {
      left: 0,
    },

    slideNextIn : function() {
      TweenMax.to ( '#next-slide', 1, {
        'left' : Courses.content.slidePosition.left,
      });

      $('.apollo-content').scrollTop(0);

      TweenMax.to ( '#current-slide', 1, {
        'left' : '-910px',
        'onComplete' : function() {
          $('#current-slide').html ( $('#next-slide').html() );
          $('#next-slide').css ( 'left', '910px' );
          $('#current-slide').css ( 'left', Courses.content.slidePosition.left );
          $('#next-slide').html('');

          var sectionIdx = Courses.currentCourse.currentSectionIdx;
          var slideIdx = Courses.currentCourse.currentSlideIdx;

          if ( Courses.currentCourse.unitJSON.menuItems[sectionIdx].slides[slideIdx].layout === 'custom' ) {
            if ( Courses.currentCourse.timelines[sectionIdx] !== undefined
              && Courses.currentCourse.timelines[sectionIdx][slideIdx] !== undefined )
                Courses.currentCourse.timelines[sectionIdx][slideIdx].play();
          }
          else {
            Courses.content.updateProgress();
          }

          var nextSlideIdxs = Courses.content.getNextSlideIdxs();
          var nextSlideAccess = Courses.content.canLoadSlide (
            nextSlideIdxs.sectionIdx,
            nextSlideIdxs.slideIdx
          );
          
          if ( nextSlideAccess.info === false ) {
            Courses.footerNav.disableNextBtn();
          }
          else {
            Courses.footerNav.enableNavBtns();
          }
          
          Courses.popup.activatePopups();
          Courses.showSlideInfo();
        },
      });
    },

    previous : function() {
      if ( Courses.footerNav.btnsEnabled ) {
        var slideIdx = Courses.currentCourse.currentSlideIdx,
            sectionIdx = Courses.currentCourse.currentSectionIdx;

        if ( slideIdx > 0 ) {
          slideIdx = Courses.currentCourse.currentSlideIdx - 1;
        }
        else {
          if ( sectionIdx > 0 ) {
            sectionIdx--;
            slideIdx = Courses.currentCourse.unitJSON.menuItems[sectionIdx].slides.length - 1;
          }
        }

        Courses.content.loadSlide (
          sectionIdx, slideIdx, '#previous-slide', Courses.content.slidePreviousIn
        );

        Courses.footerNav.disableNavBtns();
      }
    },

    slidePreviousIn : function() {
      TweenMax.to ( '#previous-slide', 1, {
        'left' : Courses.content.slidePosition.left,
      });

      $('.apollo-content').scrollTop(0);

      TweenMax.to ( '#current-slide', 1, {
        'left' : '910px',
        'onComplete' : function() {
          $('#current-slide').html ( $('#previous-slide').html() );
          $('#previous-slide').css ( 'left', '-910px' );
          $('#current-slide').css ( 'left', Courses.content.slidePosition.left );
          $('#previous-slide').html('');

          var sectionIdx = Courses.currentCourse.currentSectionIdx;
          var slideIdx = Courses.currentCourse.currentSlideIdx;

          if ( Courses.currentCourse.unitJSON.menuItems[sectionIdx].slides[slideIdx].layout === 'custom' ) {
            if ( Courses.currentCourse.timelines[sectionIdx] !== undefined
              && Courses.currentCourse.timelines[sectionIdx][slideIdx] !== undefined )
                Courses.currentCourse.timelines[sectionIdx][slideIdx].play();
          }
          else {
            Courses.content.updateProgress();
          }

          Courses.footerNav.enableNavBtns();
          Courses.popup.activatePopups();
          Courses.showSlideInfo();
        },
      });
    },

    updateProgress : function() {
      // console.log(sectionIdx);
    },

    setCurrSlideNotStarted : function() {
      Courses.content.setSlideStatus (
        Courses.currentCourse.currentSectionIdx,
        Courses.currentCourse.currentSlideIdx, 0, true
      );

      Courses.content.saveJSONTrainingData();
    },

    setCurrSlideIncomplete : function() {
      Courses.content.setSlideStatus (
        Courses.currentCourse.currentSectionIdx,
        Courses.currentCourse.currentSlideIdx, 1, true
      );
      // console.log('inc', Courses.currentCourse.currentSectionIdx, Courses.currentCourse.currentSlideIdx);
      // console.log(Courses.currentCourse.JSONTrainingData.sections[Courses.currentCourse.currentSectionIdx].slides[Courses.currentCourse.currentSlideIdx]);
      Courses.content.saveJSONTrainingData();
    },

    setCurrSlideComplete : function() {
      CourseLog.addEntry ( 9, JSON.stringify({sectionIdx: Courses.currentCourse.currentSectionIdx, slideIdx: Courses.currentCourse.currentSlideIdx}) );

      Courses.content.setSlideStatus (
        Courses.currentCourse.currentSectionIdx,
        Courses.currentCourse.currentSlideIdx, 2, true
      );

      Courses.content.saveJSONTrainingData();
    },
  },

  assessment : {
    saveAssessmentAttempt : function() {
      var sendData = {
        assessmentID : Assessment.player.assessmentID,
        percentageScore : Assessment.player.percentageScore,
        status : Assessment.player.status,
      };

      $.ajax({
        url: '/AJAX-assessment/saveAttempt',
        data: sendData,
        type: 'post',
        dataType: 'text',
        success: function ( returnedData ) {
          // console.log('saveAssessmentAttempt:returnedData', returnedData);
        },
      });

      if ( Assessment.player.status === 'P' ) {
        Courses.content.updateStatus ( Courses.currentSlideIndex, 2, false );
      }
    },

    assessmentPassed : function() {
      CourseLog.addEntry ( 10, '' );

      Courses.content.setSlideStatus ( Courses.currentCourse.currentSectionIdx, Courses.currentCourse.currentSlideIdx, 2 );
      Courses.content.saveJSONTrainingData();
    },
  },

  accessibility : {
    zoom : 1,

    invert : function() {
      $('body').toggleClass ( 'inverted' );
    },

    setHotKeysOn : function() {
      CourseLog.addEntry ( 24, '' );
      $('body')
        .off ( 'keydown.hotKeys' )
        .on  ( 'keydown.hotKeys', function ( evt ) {
          // console.log(evt.keyCode);
          CourseLog.addEntry ( 22, JSON.stringify({keyCode: evt.keyCode}) );

          switch ( evt.keyCode ) {
            case 77:// M
              Courses.menu.toggle();
              break;
            case 39:// RIGHT
              CourseLog.addEntry ( 3, '' );
              Courses.content.next();
              break;
            case 37:// LEFT
              CourseLog.addEntry ( 4, '' );
              Courses.content.previous();
              break;
            case 90:// Z
              Courses.accessibility.zoomIn();
              break;
            case 88:// X
              Courses.accessibility.zoomOut();
              break;
            // - ESC FOR THE CLOSING OF POPUPS HAS BEEN MOVED TO THE MOUSE EVENT
            case 80:// P
              Courses.popup.showKeyPopup();
              break;
            case 73:// I
              Courses.showSlideInfo();
              break;
            case 70:// F
              Courses.toggleFullScreen();
              break;
            case 72:// H
              Courses.utils.help.toggle();
              break;
            case 78:// N
              Courses.utils.notes.toggle();
              break;
          }
        });
    },

    setHotKeysOff : function() {
      CourseLog.addEntry ( 25, '' );
      $('body')
        .off ( 'keydown.hotKeys' );
    },

    zoomIn : function() {
      CourseLog.addEntry ( 18, '' );

      Courses.accessibility.zoom += 0.25;

      TweenMax.to ( '#current-slide', 0.5, {
        'transform' : 'scale(' + Courses.accessibility.zoom + ')',
      });

      Courses.accessibility.zoomPanOn();
    },

    zoomOut : function() {
      CourseLog.addEntry ( 19, '' );

      if ( Courses.accessibility.zoom > 1 ) {
        Courses.accessibility.zoom -= 0.25;

        TweenMax.to ( '#current-slide', 0.5, {
          'transform' : 'scale(' + Courses.accessibility.zoom + ')',
        });
      }

      if ( Courses.accessibility.zoom === 1 ) {
        Courses.accessibility.zoomPanOff();
      }
    },

    zoomPanOn : function() {
      $('#apollo-content')
        .off ( 'mousemove' )
        .on  ( 'mousemove', function ( evt ) {
          var x = evt.clientX - $('#current-slide').parent().offset().left,
              y = evt.clientY - $('#current-slide').parent().offset().top,
              xPerc = x / $('#apollo-content').width(),
              yPerc = y / $('#apollo-content').height(),

              wDiff = ( $('#apollo-content').width() * Courses.accessibility.zoom ) - $('#apollo-content').width(),
              hDiff = ( $('#apollo-content').height() * Courses.accessibility.zoom ) - $('#apollo-content').height();

          TweenMax.to ( '#current-slide', 0.2, {
            'left' : -(xPerc * wDiff),
            'top'  : -(yPerc * hDiff),
          });
        });
    },

    zoomPanOff : function() {
      $('#apollo-content')
        .off ( 'mousemove' );

      TweenMax.to ( '#current-slide', 0.5, {
        'left' : 0,
        'top'  : 0,
      });
    },

    fullScreen : {
      init : function() {
        $(document).on('webkitfullscreenchange mozfullscreenchange fullscreenchange', function(e) {
            var isFullScreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;

            if ( ! isFullScreen ) {
              Courses.apolloExitFullScreen();
            }
        });
      },
    },
  },

  showSlideInfo : function() {
    if ( $('#current-slide instructions').length > 0 ) {
      var instructions = $('#current-slide instructions').html();

      var popupID = $('#current-slide instructions').attr ( 'data-popup-id' );

      Courses.popup.showDynamicPopup ( instructions, Courses.popup.getOptions ( popupID ) );
    }
  },

  effects : {

  },

  dev : {
    // - THESE ARE TOOLS WE WILL DEACTIVATE AND STORE IN A SEPARATE FILE AFTER COMPLETING DEV
    startRecordingSuspendData : function() {
      window.suspendData = {
        sections : {}
      };
    },

    recordSlide : function() {
      // - s = status[0,1,2] - CUSTOM, ASSESSMENTS AND NORMAL SLIDES WITH POPUPS CAN BE 0, 1 OR 2 ALL OTHERS 0 OR 2
      // - p = POPUPS VIEWED 0 OR 1
      // - c = CUSTOM SLIDE
      // - a = ASSESSMENT SLIDE
      // - d = DATA GATHERED FOR A c OR a

      var secIdx = Courses.currentCourse.currentSectionIdx;
      var sldIdx = Courses.currentCourse.currentSlideIdx;

      if ( window.suspendData.sections[secIdx] === undefined ) {
        window.suspendData.sections[secIdx] = {
          slides : {},
        };
      }

      if ( window.suspendData.sections[secIdx].slides[sldIdx] === undefined ) {
        window.suspendData.sections[secIdx].slides[sldIdx] = {
          s : 0,
          c : 0,
          a : 0,
          d : {},
        };
      }

      // - IF IT'S CUSTOM, SET c = 1
      if ( Courses.currentCourse.unitJSON.menuItems[secIdx].slides[sldIdx].layout === 'custom' ) {
        window.suspendData.sections[secIdx].slides[sldIdx].c = 1;
      }

      // - IF IT'S AN ASSESSMENT, SET a = 1
      if ( Courses.currentCourse.unitJSON.menuItems[secIdx].slides[sldIdx].layout === 'assessment' ) {
        window.suspendData.sections[secIdx].slides[sldIdx].a = 1;
      }

      // - EVERYTHING ELSE IS CREAM CHEESE
    },

    autoRecordAll : function() {
      // - INITIALISE
      Courses.dev.startRecordingSuspendData();
      // - RECORD FIRST SLIDE
      Courses.dev.recordSlide();
      // - SET INTERVAL
      var i = setInterval ( function() {
        $('#next-btn').click();
        setTimeout ( Courses.dev.recordSlide, 1000 );
      }, 3000 );
    },
  },
};
